import React from 'react';
import Gallery from '../components/Gallery';
import { prePostWeddingImages } from '../data/images';

const PrePostWedding = () => {
  return (
    <div className="gallery-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Pre & Post Wedding</h1>
          <p>
            Beautiful pre-wedding and post-wedding photography sessions that tell your love story with artistic flair. 
            Capture the romance, excitement, and joy of your special journey together.
          </p>
        </div>
      </section>
      
      <section className="gallery-section">
        <div className="container">
          <Gallery images={prePostWeddingImages} sectionId="pre-post-wedding" />
        </div>
      </section>

    </div>
  );
};

export default PrePostWedding;
